module.exports = __webpack_public_path__ + "static/media/video_1_img.b743b452.jpg";